module.exports = __webpack_public_path__ + "static/media/icon-O2O-system5.ab68a1eb.png";